import React from 'react'

const Data_Policy = () => {
  return (
    <div className='bg-white'>
      <div className="mt-5 ml-5 w-[95%] md:w-[90%] md:mx-auto md:px-20 px-4">
        {/* FAQ Section */}
        <h1 className="md:text-[24px] text-[10px] font-semibold mt-5 md:pt-10 pt-5">
          FREQUENTLY ASKED QUESTIONS
        </h1>
        <p className="inline md:text-[14px] font-bold text-[10px] text-[#979797] break-words whitespace-normal italic">
          Last updated on 22nd March 2025
        </p>

        <div className='md:h-8 h-2'></div>

        <div className="mt-10 md:text-[32px] text-[10px] text-black leading-relaxed font-normal md:space-y-6 space-y-4">
          <p><span className="font-bold">1. What is Farmers Network?</span><br />
          <div className='md:h-7 h-3'></div>
            Farmers Network is an online platform designed to connect farmers, agribusinesses, experts, and agricultural service providers. It helps users share knowledge, access resources, buy and sell farm inputs or produce, and stay informed on the latest in agriculture.
          </p>

          <p><span className="font-bold">2. Who can join the platform?</span><br />
            Anyone involved in agriculture can join — including smallholder farmers, commercial farmers, agronomists, suppliers, cooperatives, buyers, students, and NGOs.
          </p>

          <p><span className="font-bold">3. Is registration free?</span><br />
            Yes, basic registration is usually free. Some advanced services (e.g., premium features, advertising, or expert consultations) may require a paid subscription.
          </p>

          <p><span className="font-bold">4. How do I create an account?</span><br />
            Click the “Sign Up” button on the homepage, fill in your details (name, location, phone/email, etc.), and follow the steps to verify your account.
          </p>

          <p><span className="font-bold">5. What can I do on the platform?</span><br />
            <ul className="list-disc ml-6 md:ml-8">
              <li>Better planning & management</li>
              <li>Connect with verified service providers</li>
              <li>Access markets</li>
              <li>Connect with other farmers</li>
              <li>Participate in communities</li>
              <li>Post and browse agricultural products</li>
              <li>Access training materials and guides</li>
              <li>Join discussions or forums</li>
              <li>Get resources, updates on weather, markets, and trends</li>
              <li>Advertise farm products or services</li>
            </ul>
          </p>

          <p><span className="font-bold">6. How do I post my farm produce or services?</span><br />
            Once logged in, go to the Marketplace or My Listings section, click “Add New Post”, upload photos and details, and submit. Your post will be reviewed and published shortly.
          </p>

          <p><span className="font-bold">7. Is my data safe on the platform?</span><br />
            Yes. We use secure servers and encryption to protect your data. For more details, see our Privacy Policy and Data Policy.
          </p>

          <p><span className="font-bold">8. Can I use the platform on my mobile phone?</span><br />
            Yes! Our website is mobile-friendly, and we also offer a mobile app (if available) for Android and iOS devices.
          </p>

          <p><span className="font-bold">9. How can I connect with an expert or extension officer?</span><br />
            You can go to the "Ask an Expert" or "Support" section, where you can submit your question or request. Some platforms may have a directory of verified experts you can message directly.
          </p>

          <p><span className="font-bold">10. How do I report a problem or suspicious user?</span><br />
            Go to the “Contact Us” page or use the “Report” button on the user’s profile or post. You can also email us directly at <a href="mailto:support@farmnet.africa">support@farmnet.africa</a>.
          </p>

          <p><span className="font-bold">11. Can I advertise my agricultural business?</span><br />
            Yes! We offer advertising options for agri-businesses, input dealers, service providers, and NGOs. Check our Advertise with Us page or contact us for rates and options.
          </p>

          <p><span className="font-bold">12. Is the Farmers Network available in local languages?</span><br />
            Some features may be available in local languages depending on your region. We're working to expand support to make the platform more accessible.
          </p>

          <p><span className="font-bold">13. How do I delete my account?</span><br />
            You can go to Settings > Account and click “Delete Account.” If you need help, contact our support team.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Data_Policy
